import { BaseHttpResource } from "src/app/infrastructure/BaseHttpResource";
import httpClient from "./httpClient";

// const BASE_URL = 'https://api.lama.im/api';
import {env} from "../../../runtimeEnv";

const BASE_URL = env('API_URI');
const defaultOptions = {
  timeOffset: true,
  responseType: 'json',
  accessType: 'json',
  contentType: 'json'
};

const httpResource = new BaseHttpResource(BASE_URL, httpClient, defaultOptions);

export default httpResource;